import { Button, Grid } from '@material-ui/core';
import React, { memo, useEffect, useMemo, useState } from 'react';
import { useLang } from '../../util/lang';
import ImageButton from '../../pages/SmileDesign/ImageButton';
import { usePatientsStyles } from '../../style/usePatientsStyles';
import Modal from '../Modal/modal';
import NewCaseModalContent from '../NewCase/NewCaseContent';
import instance from '../../axios-default';
import CreateButton from './CreateButton/CreateButton';

const NewAlignerCaseModalButton = ({ patientId = undefined }) => {
    const isMarieGroup = useMemo(() => {
        let value = JSON.parse(localStorage.getItem('isMarieGroup'));
        return value;
    }, []);
    const get = useLang();
    const [isOpen, setIsOpen] = useState(false);

    const [productMatrix, setProductMatrix] = useState(null);
    const [CaseOptionTypeArr, setCaseOptionTypeArr] = useState([]);
    const [selectCaseOptionType, setSelectCaseOptionType] = useState(null);
    const doctor_dist_id = JSON.parse(localStorage.getItem('doctor_dist_id'));

    const classes = usePatientsStyles();

    useEffect(() => {
        const getProductMatrix = async () => {
            const {
                data: { pm },
            } = await instance.get(`/productmatrix/productmatrixForDr`);
            setProductMatrix(pm);
            console.log('pm: ', pm);
        };

        const getNewCaseOptionType = async () => {
            const result = await instance.get(`/case/getcaseoption/${doctor_dist_id}`);
            if (result.data.case_options.length > 0) {
                setCaseOptionTypeArr(result.data.case_options);
                setSelectCaseOptionType(result.data.case_options[0].opt1);
            }
        };

        getProductMatrix();
        getNewCaseOptionType();
    }, []);

    const formatNewCaseLink = (v, selectCaseOptionType, currentPatientId) => {
        return `/patients/${currentPatientId}/newCase/${v['case_type']}`;
    };

    return (
        <>
            <CreateButton
                name={get('@Patients.new_trioclear_case')}
                onClick={() => setIsOpen(true)}
                icon="/img/createCase/createCaseIcon/button_icon1.png"
            />

            <Modal
                className="modal"
                modal="NewCaseModal"
                title={
                    get('@PatientInfo.case_info.actionsList.createNewCaseForPatient') + ' ' + get('@Patients.options')
                }
                open={isOpen}
                handleClose={() => setIsOpen(false)}
                modalSize="md"
                submitButton={false}
            >
                {
                    <NewCaseModalContent
                        productMatrix={productMatrix}
                        caseOptionTypeArr={CaseOptionTypeArr}
                        LinkToFunc={formatNewCaseLink}
                        selectCaseOptionType={selectCaseOptionType}
                        currentPatientId={patientId}
                        currentCaseId={undefined}
                        handleCaseOptionTypeChange={(e) => setSelectCaseOptionType(e.target.value)}
                    />
                }
            </Modal>
        </>
    );
};

export default memo(NewAlignerCaseModalButton);
